import { requestHeaders } from '@/api';
import type { PatientDetails } from '@/components/MergePatients/MergePatientsModalContent';
import { MergePatientsModalFooter } from '@/components/MergePatients/MergePatientsModalFooter';
import settings from '@/data/constants';
import { getAuthData } from '@/data/service/authService';
import { toast } from '@montugroup/design-system';
import Box from '@mui/material/Box';

type MergePatientsModalConfirmationProps = {
  onClose: () => void;
  primaryPatientDetails: PatientDetails;
  secondaryPatientDetails: PatientDetails;
};

export const MergePatientsModalConfirmation = ({
  onClose,
  primaryPatientDetails,
  secondaryPatientDetails,
}: MergePatientsModalConfirmationProps) => {
  const { user } = getAuthData();

  const mergePatientProfiles = async () => {
    try {
      if (
        !primaryPatientDetails.patientCode ||
        !secondaryPatientDetails.patientCode ||
        primaryPatientDetails.patientCode === secondaryPatientDetails.patientCode
      ) {
        return;
      }

      const requestBody = {
        fromPatientCode: secondaryPatientDetails.patientCode,
        toPatientCode: primaryPatientDetails.patientCode,
        user_id: user?.id,
      };

      const url = `${settings.url}/patient/mergePatientProfiles`;

      const response = await fetch(url, {
        method: 'PUT',
        headers: requestHeaders(),
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`${response.status}`);
      }

      onClose();
      toast.success('Patient profiles have been merged successfully.');
    } catch (error) {
      onClose();

      const errorMessage = 'A problem occurred while trying to merge patient profiles.';
      toast.error(errorMessage);
      console.error(errorMessage, error);
    }
  };

  return (
    <>
      <Box>
        <Box>Are you sure you want to proceed with merging the profiles? This action cannot be undone.</Box>
      </Box>
      <Box display="flex" justifyContent="flex-end" gap={2}>
        <MergePatientsModalFooter onCancel={onClose} onProceed={mergePatientProfiles} proceedLabel={'Proceed'} />
      </Box>
    </>
  );
};
